// Client-side persistence for the recruiting matching demo.

// only swap point — replace localStorage reads/writes with
//   GET  /api/opportunities/:id/matches
//   POST /api/opportunities/:id/matches/:advisor_id/approve
//   POST /api/opportunities/:id/matches/:advisor_id/reject
//   POST /api/opportunities/:id/matches/:advisor_id/reset
//   POST /api/opportunities/:id/matches/send

const KEY_PREFIX = 'recruiting-matches:v1:'

function storageKey(oppId) {
  return `${KEY_PREFIX}${oppId}`
}

function safeParse(raw) {
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object') return parsed
  } catch (_) {
    // fall through
  }
  return null
}

/*
 * Full run state for an opportunity.
 */
export function getRunState(oppId) {
  if (!oppId) return null
  return safeParse(localStorage.getItem(storageKey(oppId)))
}

export function saveRunState(oppId, state) {
  if (!oppId || !state) return
  localStorage.setItem(storageKey(oppId), JSON.stringify(state))
}

export function clearRunState(oppId) {
  if (!oppId) return
  localStorage.removeItem(storageKey(oppId))
}

/** Convenience: just the approved subset. Used by the accordion + count. */
export function getApprovedMatches(oppId) {
  const state = getRunState(oppId)
  if (!state || !Array.isArray(state.matches)) return []
  return state.matches.filter((m) => m.status === 'approved')
}

/** Convenience: pending count (for the empty-state gating on Send). */
export function getApprovedCount(oppId) {
  return getApprovedMatches(oppId).length
}

/**
 * Set an individual match's status. Passing `null` for status leaves the
 * match untouched — callers should use one of pending/approved/rejected.
 */
export function setMatchStatus(oppId, advisorId, status) {
  const state = getRunState(oppId)
  if (!state || !Array.isArray(state.matches)) return
  const m = state.matches.find((x) => x.advisor_id === advisorId)
  if (!m) return
  m.status = status
  saveRunState(oppId, state)
}

/* Bulk approve every match currently in pending. */
export function approveAll(oppId) {
  const state = getRunState(oppId)
  if (!state || !Array.isArray(state.matches)) return
  state.matches.forEach((m) => {
    if (m.status === 'pending') m.status = 'approved'
  })
  saveRunState(oppId, state)
}



// WEBPACK FOOTER //
// ./src/services/recruitingMatchesStore.js